// A product list's first page as the server rendered it (pageContext.storefrontCategoryList): the browser
// starts from it when it is the same list — same category, sort, page, search and language.
export const CATALOG_PAGE_SIZE = 24

export const catalogSeedKey = ({ seedFor, sortBy, page, textSearch = "", language }) => [seedFor, sortBy, page, textSearch, language].join("|")

// the cards whose covers load first, at once: the first row on a desktop, the first two on a phone
export const FIRST_ROW = 4
